var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19720",
    "data-name": "Group 19720",
    transform: "translate(-18057.647 14753.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247978",
    "data-name": "Path 247978",
    d: "M250.874,905.255H236.8c-.039-.627.092-1.337,1.286-1.506,1.058-.15,1.147-.852,1.15-1.056h9.185c.273,1.036.878,1.036.879,1.036,1.859.109,1.653,1.24,1.57,1.526Z",
    transform: "translate(17821.85 -15640.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247979",
    "data-name": "Path 247979",
    d: "M208.949,1079.017l-.014,1.247H192.963l-.014-1.059a1.5,1.5,0,0,1,.636-.716h14.837a1.175,1.175,0,0,1,.526.528Z",
    transform: "translate(17864.697 -15813.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247996",
    "data-name": "Path 247996",
    d: "M284.513,58.731h-6.252c-1.251-.526-3.875-3.918-3.625-4.148a16.969,16.969,0,0,1,1.8-.988c2.091-1,.9-.378,2.04-.984s2.805-3.734,2.805-3.734c-.513,1-3.28,1.086-4.482,1.646a10.181,10.181,0,0,0-1.54.814c-.7-.124.088-1.3,0-1.121s-.713.988-1.227.571-.726-1.02-.1-1.437,4.143-3.412,4.143-3.412a5.931,5.931,0,0,1-.288-2.48,7.484,7.484,0,0,0,2.04,1.777,8.137,8.137,0,0,1,6.76,5.42c1.189,3.873-1.772,7.7-2.078,8.076Z",
    transform: "translate(17785.738 -14796.786)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnight);
export default __webpack_public_path__ + "static/media/knight.a8dc73caf97c8f001bb3ee19a68931c8.svg";
export { ForwardRef as ReactComponent };